<!-- dashboard/routes/dashboard/settings/account/components/auto-resolve/TabNavigation.vue -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  labelCount: {
    type: Number,
    default: 0,
  },
  agentCount: {
    type: Number,
    default: 0,
  },
  teamCount: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['update:modelValue']);

const tabs = computed(() => [
  { key: 'labels', label: 'Etiquetas', count: props.labelCount },
  { key: 'agents', label: 'Agentes', count: props.agentCount },
  { key: 'teams', label: 'Times', count: props.teamCount },
  { key: 'padrão', label: 'Padrão', count: null },
]);

const selectTab = (key) => {
  emit('update:modelValue', key);
};
</script>

<template>
  <div class="flex gap-1 p-1 mb-6 bg-n-alpha-1 rounded-lg w-fit">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      @click="selectTab(tab.key)"
      :class="[
        'relative px-3 py-1.5 text-sm font-medium rounded-md transition-all',
        modelValue === tab.key
          ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
          : 'text-n-slate-10 hover:text-n-slate-12',
      ]"
    >
      <span class="flex items-center gap-1.5">
        {{ tab.label }}
        <span
          v-if="tab.count !== null"
          :class="[
            'min-w-[18px] px-1 py-0.5 text-xs rounded text-center',
            modelValue === tab.key
              ? 'bg-n-slate-9/10 text-n-slate-11'
              : 'bg-n-alpha-1 text-n-slate-10',
          ]"
        >
          {{ tab.count }}
        </span>
      </span>
    </button>
  </div>
</template>